import { useState } from "react";
import { toast } from "react-toastify";
import { callApi } from "../../api";
import useTimeZone from "../../views/ShiftReports/hooks/useTimeZone";
import { useAuth } from "../useAuth";

const LOADING_TYPES = {
  FETCH_PREPAID: "fetch_prepaid",
};

const usePrepaidItems = () => {
  const { tzConverter } = useTimeZone();

  const UTCtoLocal = (utc) => tzConverter(utc, "YYYY-MM-DD");

  const [prepaid, setPrepaid] = useState(null);
  const [loading, setLoading] = useState(null);

  const [updatedPrepaid, setUpdatedPrepaid] = useState(null);

  const { selectedBusinessDetail } = useAuth();

  const getPrepaidFromCardNumber = async ({ card, cardNumber }) => {
    setLoading(LOADING_TYPES.FETCH_PREPAID);
    const res = await callApi(
      `/protected/business/${selectedBusinessDetail.id}/prepaid/${card}/${cardNumber}`
    );
    if (res && res.status === true) {
      setPrepaid(res.data);
    } else {
      toast.error(res?.message || "Failed to fetch prepaid items!");
    }
    setLoading(null);
  };

  const getPrepaidFromSearch = async (data, basic) => {
    setLoading(LOADING_TYPES.FETCH_PREPAID);
    const res = await callApi(
      `/protected/business/${
        selectedBusinessDetail.id
      }/prepaid/search?q=${encodeURIComponent(JSON.stringify(data))}`
    );
    if (res && res.status === true) {
      if (!basic) setPrepaid(res.data);
    } else if (!basic)
      toast.error(res?.message || "Failed to fetch prepaid items!");
    setLoading(null);
    return res;
  };

  const getMembershipFromQuery = async (data) => {
    setLoading(LOADING_TYPES.FETCH_PREPAID);
    const temp = {};
    Object.keys(data).forEach((x) => {
      if (data[x]!==undefined) temp[x] = data[x];
    });
    const result = `?${new URLSearchParams(temp).toString()}`;
    const res = await callApi(
      `/protected/business/${selectedBusinessDetail.id}/membership/search${result}`
    );
    if (res && res.status === true) {
      setPrepaid(
        res.data?.filter(
          (x) =>
            UTCtoLocal(x.created_at) >= data.start &&
            UTCtoLocal(x.created_at) <= data.end
        )
      );
    } else toast.error(res?.message || "Failed to fetch membership items!");
    setLoading(null);
    return res;
  };

  const getMembershipFromSearch = async (period) => {
    setLoading(LOADING_TYPES.FETCH_PREPAID);
    const res = await callApi(
      `/protected/business/${selectedBusinessDetail.id}/membership/search${
        period ? `?start=${period.start}&end=${period.end}` : ""
      }`
    );
    setLoading(null);
    return res;
  };

  return {
    prepaid,
    setPrepaid,
    loadingFetch: loading === LOADING_TYPES.FETCH_PREPAID,
    getPrepaidFromSearch,
    getMembershipFromSearch,
    getMembershipFromQuery,
    getPrepaidFromCardNumber,
    updatedPrepaid,
    setUpdatedPrepaid,
  };
};

export default usePrepaidItems;
